(function () {
  var cartEl = document.querySelector('[data-lp-cart]');
  if (!cartEl || window.LPCart) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var moneyFormat = cartEl.dataset.moneyFormat || '${{amount}}';
  var lastCart = null;

  function formatMoney(cents, format) {
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var kind = m ? m[1] : 'amount';
    function fmt(n, dec, th, ds) {
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th) + (parts[1] ? ds + parts[1] : '');
    }
    var v;
    switch (kind) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }
  function money(c) { return formatMoney(c, moneyFormat); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  function notifyTheme(cart) {
    try {
      var ev = new Event('shopify:cart:lines-update', { bubbles: true });
      ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function fetchCart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function render(cart) {
    lastCart = cart;
    notifyTheme(cart);
    var box = cartEl.querySelector('[data-lp-cart-items]');
    cartEl.querySelector('[data-lp-cart-count]').textContent = '(' + cart.item_count + ')';
    cartEl.querySelector('[data-lp-cart-subtotal]').textContent = money(cart.total_price);
    if (!cart.items.length) {
      box.innerHTML = '<div class="lp-cart__empty">' + esc(cartEl.dataset.empty || 'Your cart is empty') + '</div>';
    } else {
      var lines = cart.items.map(function (it, i) { return { it: it, line: i + 1 }; });
      lines.sort(function (a, b) { return b.it.final_line_price - a.it.final_line_price; });
      box.innerHTML = lines.map(function (pl) {
        var it = pl.it;
        var v = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=180' : '';
        var orig = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="lp-cart__item" data-line="' + pl.line + '">' +
          (img ? '<a href="' + esc(it.url) + '"><img class="lp-cart__itimg" src="' + esc(img) + '" alt=""></a>' : '<span class="lp-cart__itimg"></span>') +
          '<span class="lp-cart__itmid"><b>' + esc(it.product_title) + '</b>' + (v ? '<em>' + esc(v) + '</em>' : '') +
          '<span class="lp-cart__qty"><button type="button" data-lp-q="' + pl.line + '" data-d="-1" aria-label="Decrease">&minus;</button><span>' + it.quantity +
          '</span><button type="button" data-lp-q="' + pl.line + '" data-d="1" aria-label="Increase">+</button></span></span>' +
          '<span class="lp-cart__itright"><b>' + money(it.final_line_price) + '</b>' + orig +
          '<button type="button" class="lp-cart__remove" data-lp-q="' + pl.line + '" data-d="0">' + esc(cartEl.dataset.remove || 'Remove') + '</button></span></div>';
      }).join('');
    }
    var ups = cartEl.querySelector('[data-lp-cart-upsell]'), uid = cartEl.dataset.upsellId;
    if (ups && uid) {
      var has = cart.items.some(function (it) { return String(it.variant_id) === String(uid); });
      ups.hidden = has || !cart.items.length;
      if (!ups.dataset.ready) {
        ups.dataset.ready = '1';
        cartEl.querySelector('[data-lp-up-img]').src = cartEl.dataset.upsellImg || '';
        cartEl.querySelector('[data-lp-up-title]').textContent = cartEl.dataset.upsellTitle || '';
        cartEl.querySelector('[data-lp-up-price]').textContent = cartEl.dataset.upsellPrice || '';
      }
    }
  }

  cartEl.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lp-q]');
    if (q && lastCart) {
      var line = +q.dataset.lpQ, d = +q.dataset.d, it = lastCart.items[line - 1];
      if (!it) return;
      var row = q.closest('.lp-cart__item'); if (row) row.setAttribute('aria-busy', 'true');
      changeLine(line, d === 0 ? 0 : Math.max(0, it.quantity + d)).then(render);
      return;
    }
    if (e.target.closest('[data-lp-up-add]')) {
      addItems([{ id: +cartEl.dataset.upsellId, quantity: 1 }]).then(fetchCart).then(render);
      return;
    }
    if (e.target.closest('[data-lp-cart-close]')) close();
  });

  function open(cart) {
    var p = cart ? Promise.resolve(cart) : fetchCart();
    return p.then(function (c) {
      render(c);
      cartEl.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = cartEl.querySelector('.lp-cart__x'); if (x) x.focus({ preventScroll: true });
    });
  }
  function close() {
    cartEl.hidden = true;
    document.documentElement.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !cartEl.hidden) close(); });

  /* Header cart icon → this cart (instead of the theme's default drawer / cart page) */
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], [aria-controls="cart-drawer"], a.action__cart, a[href$="/cart"]');
    if (!t || cartEl.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  window.LPCart = { open: open, close: close, add: addItems, refresh: function () { return fetchCart().then(render); } };
})();
